import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useTransform, useScroll } from "framer-motion";
import { MaskedLines } from "@/components/Reveal";
import { IndiaMap } from "@/components/IndiaMap";
import { HeroDoodles } from "@/components/Doodles";
import { TM } from "@/components/TM";

export const Hero = ({ onProveIt }) => {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const { scrollY } = useScroll();
  const lift = useTransform(scrollY, [0, 600], [0, 60]);
  const fade = useTransform(scrollY, [0, 550], [1, 0]);

  return (
    <section ref={ref} className="hero relative min-h-[560px] overflow-hidden" data-testid="hero-section">
      <HeroDoodles heroRef={ref} mapRef={mapRef} />
      <motion.div ref={mapRef} style={{ opacity: fade, y: lift }} className="hero-map absolute">
        <IndiaMap className="w-full h-full" stroke="#DD7A3A">
          <div className="hero-copy absolute -translate-x-1/2 -translate-y-1/2 flex flex-col items-stretch text-center">
            <MaskedLines
              testId="hero-heading"
              lines={["Are you a ", <>TruCitizen<TM />?</>]}
              className="hero-heading font-display text-[var(--ink)] leading-[1.04] tracking-[-0.025em] whitespace-nowrap"
              delay={0.5}
            />
            <motion.div
              initial={{ opacity: 0, y: 16, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ delay: 1.15, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="hero-cta-wrap flex flex-col items-center"
            >
              <button onClick={onProveIt} data-testid="prove-it-button" className="hero-cta btn-saffron btn-shine min-w-[72%] max-w-full whitespace-nowrap">
                Prove It
                <span className="btn-arrow" aria-hidden="true">→</span>
              </button>
              <Link to="/premium" className="hero-pro-link font-semibold text-[var(--saffron-deep)] hover:text-[var(--ink)] underline underline-offset-4 decoration-[rgba(232,106,34,0.4)] transition-colors" data-testid="hero-become-pro-link">
                Become Pro →
              </Link>
            </motion.div>
          </div>
        </IndiaMap>
      </motion.div>
    </section>
  );
};
